var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFromLanguageFile } from "../../../app";
import { removeFromBetSlip } from "../../../services/betslip.services";
import { dateTimeFormat } from "../../../lib/misc.functions";
import Lock from "../../../assets/feather/lock.svg";
var getLeagueName = function (item) {
    try {
        var country = getFromLanguageFile(item.sportEvent.cGNId) || item.sportEvent.cGN;
        var league = getFromLanguageFile(item.sportEvent.cNId) || item.sportEvent.cN;
        return "".concat(country, ", ").concat(league);
    }
    catch (e) {
        return "".concat(item.sportEvent.cGN, ", ").concat(item.sportEvent.cN);
    }
};
var getOddName = function (item) {
    try {
        var name_1 = getFromLanguageFile(item.outcome.onId);
        if (name_1.toString().includes('{hv}-{av}')) {
            return item.outcome.oN;
        }
        var t1 = getFromLanguageFile(item.sportEvent.eP[0].nameId) || item.sportEvent.eP[0].participantName;
        var t2 = getFromLanguageFile(item.sportEvent.eP[1].nameId) || item.sportEvent.eP[1].participantName;
        return name_1
            .replaceAll('{t1}', t1)
            .replaceAll('{t2}', t2)
            .replaceAll('{h}', item.market.sOV)
            .replaceAll('{-h}', -1 * item.market.sOV);
    }
    catch (e) {
        return item.outcome.oN;
    }
};
var getMarketName = function (item) {
    try {
        return getFromLanguageFile(item.market.nId) || item.market.mN;
    }
    catch (e) {
        return item.market.mN;
    }
};
export default function NewBetslipItem(props) {
    var _a, _b, _c, _d;
    var item = props.item;
    var isLive = item.sportEvent.cur;
    var isLocked = item.market.mS < 0 || item.sportEvent.iSP == 1;
    var isUnavailable = !isLocked && (Number(item.outcome.fOW) <= 1 || item.market.mS === 0 || item.market.mS >= 2);
    var leagueName = getLeagueName(item);
    var oddName = getOddName(item);
    var marketName = getMarketName(item);
    var homeName = ((_b = (_a = item.sportEvent.eP) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.participantName) || '';
    var awayName = ((_d = (_c = item.sportEvent.eP) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.participantName) || '';
    var score = (isLive && item.sportEvent.cur) ? item.sportEvent.cur : null;
    var dateStr = dateTimeFormat(item.sportEvent.eD);
    var handleRemoveItem = function () {
        removeFromBetSlip(item.sportEvent, item.market, item.outcome);
    };
    return (_jsxs("div", __assign({ className: "nb-item" }, { children: [_jsx("div", __assign({ className: "nb-item-suffix" }, { children: _jsx("button", __assign({ className: "nb-item-remove-btn", onClick: handleRemoveItem }, { children: "\u00D7" }), void 0) }), void 0), _jsxs("div", __assign({ className: "nb-content" }, { children: [_jsxs("div", __assign({ className: "nb-item-top" }, { children: [_jsx("span", __assign({ className: "nb-item-league" }, { children: leagueName }), void 0), isLive
                                ? _jsx("span", __assign({ className: "nb-item-live-badge" }, { children: "LIVE" }), void 0)
                                : _jsx("span", __assign({ className: "nb-item-date" }, { children: dateStr }), void 0)] }), void 0), _jsxs("div", __assign({ className: "nb-item-main" }, { children: [_jsxs("div", __assign({ className: "nb-item-teams" }, { children: [_jsx("span", __assign({ className: "nb-item-team" }, { children: homeName }), void 0), _jsx("span", __assign({ className: "nb-item-team" }, { children: awayName }), void 0)] }), void 0), score && _jsx("span", __assign({ className: "nb-item-score" }, { children: score }), void 0), _jsx("span", __assign({ className: "nb-item-odd".concat(isLocked ? ' locked' : '') }, { children: isLocked
                                    ? _jsx("img", { alt: "lock", src: Lock, width: 15, className: "invert-color" }, void 0)
                                    : isUnavailable
                                        ? _jsx("span", { children: "-" }, void 0)
                                        : item.outcome.fOW }), void 0)] }), void 0), _jsxs("div", __assign({ className: "nb-item-bottom" }, { children: [_jsxs("span", __assign({ className: "nb-item-market-name" }, { children: [marketName, ":"] }), void 0), _jsx("span", __assign({ className: "nb-item-tip" }, { children: oddName }), void 0)] }), void 0)] }), void 0), item.errorString && (_jsx("div", __assign({ className: "nb-item-error" }, { children: item.errorString }), void 0))] }), void 0));
}
